import React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { editSingleCaseAgreement } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

const agreementTypes = [
  { value: "Not Selected", label: "Not Selected" },
  { value: "SCA", label: "SCA" },
  { value: "Waiver", label: "Waiver" },
  { value: "GAP", label: "GAP" },
];

const ScaAgreementTypeEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const agreementType = useAppSelector(
    state => state.verification.verification.singleCaseAgreement?.agreementType || "Not Selected"
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(editSingleCaseAgreement(new ReduxUpdate("agreementType", e.target.value)));
  };

  return (
    <TextField
      select
      label="Agreement Type"
      value={agreementType}
      onChange={handleChange}
      fullWidth={false}
      variant="outlined"
      margin="normal"
      style={{ width: 200 }}
    >
      {agreementTypes.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export { ScaAgreementTypeEdit };
